import { grpc, someGrpc } from "@somewear/grpc";
import { actionSetEpicHandlerBuilder } from "@somewear/model";
import type { StateObservable } from "redux-observable";
import { combineEpics } from "redux-observable";
import { from } from "rxjs";
import { mergeMap } from "rxjs/operators";

import { shapeActions } from "./shape.actions";
import { selectAllShapes } from "./shape.slice";
import type { ShapeState } from "./shape.state";

const getShapesEpic = actionSetEpicHandlerBuilder(shapeActions.getShapes, () =>
	grpc.prepareRequest(someGrpc.getShapes),
);

const createShapeEpic = actionSetEpicHandlerBuilder(
	shapeActions.createShape,
	(payload) => grpc.prepareRequestWithPayload(someGrpc.createShape, payload.data),
	{
		onPending: "Creating shape...",
		onFulfilled: `Shape created!`,
		onRejected: `Failed to create shape.`,
	},
);

const editShapeEpic = actionSetEpicHandlerBuilder(shapeActions.editShape, (payload) =>
	grpc.prepareRequestWithPayload(someGrpc.editShape, payload.data),
);

const deleteAllShapesEpic = actionSetEpicHandlerBuilder(
	shapeActions.deleteAll,
	(_, state$: StateObservable<ShapeState>) => {
		const shapes = selectAllShapes(state$.value);
		return from(shapes).pipe(
			mergeMap((shape) => grpc.prepareRequestWithPayload(someGrpc.deleteShape, shape.id)),
		);
	},
);

const deleteShapeEpic = actionSetEpicHandlerBuilder(shapeActions.deleteOne, (payload) =>
	grpc.prepareRequestWithPayload(someGrpc.deleteShape, payload.data),
);

export const shapeEpics = combineEpics<any, any, any>(
	getShapesEpic,
	createShapeEpic,
	editShapeEpic,
	deleteAllShapesEpic,
	deleteShapeEpic,
);
